import { useQuery } from '@tanstack/react-query';
import { DynamicUiData } from 'src/UI/dynamicUI/types';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';

export default function useDynamicNonFinancialData(clientId?: string): {
  nonFinancialData: DynamicUiData | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => Promise<DynamicUiData | undefined>;
} {
  const { clientId: currentClientId } = useCurrentClient();
  const effectiveClientId = clientId ?? currentClientId;
  const { data, isLoading, isError, refetch } = useQuery<DynamicUiData>({
    queryKey: ['clients', effectiveClientId, 'non-financial-data'],
  });

  const refetchData = async () => {
    const result = await refetch();
    return result.data;
  };

  return {
    nonFinancialData: data,
    isLoading,
    isError,
    refetch: refetchData,
  };
}
